import { Button } from '@approvalmax/ui';
import { PasskeyAuthButton } from 'shared/components';
import styled from 'styled-components';

export const Container = styled.form`
    display: flex;
    flex-flow: column;
    max-width: 100%;
    padding-right: 0;
    background-color: #fff;
`;

export const Card = styled.div`
    display: flex;
    flex-flow: column;
`;

export const Buttons = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 15px;
    padding-bottom: 0;
    gap: 20px;
`;

export const LoginButton = styled(Button)`
    width: 140px;
    height: 40px;
`;

export const InvisibleSubmit = styled.input`
    position: absolute;
    opacity: 0;
    left: -9999px;
    top: -9999px;
`;

export const StyledPasskeyButton = styled(PasskeyAuthButton)`
    height: 36px;
    border-radius: 0;
`;
